import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaPositionsMenuRegistry = {
    personalize_nebulaPositions: {
        label: "Nebula Positions",
        link: PAGE_URL.NEBULA_POSITIONS_PAGE,
        key: PAGE_URL.NEBULA_POSITIONS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaPositionsMenuRegistry;
